import * as React from 'react';
import { CommonOperations, ResourceOperations, IPermissions, LicenseType } from "../../store/permissions";
import { Checkbox } from 'office-ui-fabric-react';
import InfoableComponent from '../common/InfoableComponent';
import { OperationArg } from './CommonPermissions';
export enum ObjectivesAccessLevel {
    Manage = 'manage',
    View = 'view',
}
type OwnProps = {
    disabled?: (arg: OperationArg) => boolean | undefined;
    indeterminate?: (arg: OperationArg) => boolean | undefined;
    checked: (arg: OperationArg) => boolean;
    onChange: (arg: OperationArg, checked: boolean | undefined) => void;
    licenseType: LicenseType;
};

export const AdministrativePermission = (props: OwnProps) => {
    const { disabled, indeterminate, checked, onChange, licenseType } = props;
    if (licenseType !== LicenseType.Regular) {
        return null;
    }
    const arg = { operation: CommonOperations.Administrate, objectives: ObjectivesAccessLevel.Manage };
    return <InfoableComponent description={"Grants full administrative access to PPM Express, including settings in the General and Manage Resources sections."}><Checkbox
        key="Administrate app"
        label="Administrate app"
        disabled={disabled?.(arg)}
        indeterminate={indeterminate?.(arg)}
        checked={checked(arg)}
        onChange={(e, c) => onChange(arg, c)}
    /></InfoableComponent>
}
